import API from "../../../../shared/modules/API";

export default class SearchHistoryAPI {
  static API_TOKEN = null;

  static API_VERSION = 1;

  static getSearchHistoryIndex () {
    return (
      fetch(`/api/v${this.API_VERSION}/search_histories`, {
        "credentials": "same-origin",
        "headers": {
          ...API.authHeaders(),
          "Content-Type": "application/json"
        },
        "method": "GET"
      }).
        then(response => response.json())
    );
  }

  static createSearchHistory (data = {}) {
    return (
      fetch(`/api/v${this.API_VERSION}/search_histories`, {
        "body": JSON.stringify(data),
        "credentials": "same-origin",
        "headers": {
          ...API.authHeaders(),
          "Content-Type": "application/json"
        },
        "method": "POST"
      }).
        then(response => response.json())
    );
  }
}
